import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  z-index: 1000;
  background: #00000050;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
`;
